<template>
    <gcmcn-layout
        title="ALL FEED RESOURCES"
        custom-class="feed-view"
    >
        <el-button
            v-if="userIsAtLeastAdmin || userIsEntityAdmin"
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            :loading="!contentLoaded"
            @click="onCreateFeedResource"
        >
            Add feed resource
        </el-button>
        <ns-loader
            ref="nsLoader"
            :to-load="toLoad"
            :scoped="false"
            @dataFetched="onDataFetched"
        >
            <ns-loader-spinner slot="loader"></ns-loader-spinner>
            <template slot="content">
                <el-row :gutter="26" class="gcmcn-separator" :style="{height: `calc(100vh - ${this.$store.getters.pageHeight}px)`}">
                    <el-col
                        :span="13"
                        class="left-part"
                    >
                        <feed-resource-list
                            :selected-feed-resource="selectedFeedResource"
                            :feed-resources="feedResources"
                            :universes="universes"
                            :events="events"
                            @select-feed-resource="selectFeedResource"

                        ></feed-resource-list>
                    </el-col>
                    <el-col :span="11" class="right-part">
                        <div>
                            <feed-resource-form
                                v-if="displayFormView"
                                :universes="universes"
                                :feed-resource="selectedFeedResource"
                                :feed-resource-configurations="feedResourceConfigurations"
                                @feed-resource-created="feedResourceCreated"
                                @leave-form-view="leaveFormView"
                            ></feed-resource-form>
                            <feed-resource-details
                                v-else-if="selectedFeedResource"
                                :key="selectedFeedResource.uid"
                                :feed-resource="selectedFeedResource"
                                :feed-resources="feedResources"
                                :feed-resource-configurations="feedResourceConfigurations"
                                @on-update-feed-resource="onUpdateFeedResource"
                                @trigger-refresh="triggerRefresh"
                                @feed-resource-created="feedResourceCreated"
                                @unselect-feed-resource="unselectFeedResource"
                                @get-updated-feed-resource="getUpdatedFeedResource"
                            ></feed-resource-details>
                        </div>
                    </el-col>
                </el-row>
            </template>
        </ns-loader>
    </gcmcn-layout>
</template>

<script>
import FeedResourceList from './feed-resource-list.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import FeedResourceDetails from './feedResourceDetails/index.vue';
import FeedResourceForm from './feed-resource-form.vue';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import { mapGetters } from 'vuex';
export default {

    name: 'FeedResources',
    components:{
        NsLoader,
        NsLoaderSpinner,
        GcmcnLayout,
        FeedResourceList,
        FeedResourceForm,
        FeedResourceDetails
    },
    data () {
        return {
            selectedFeedResource: null,
            broadcastRights: [],
            headerHeight: 233,
            contentLoaded: false,
            feedResources: [],
            universes: [],
            events: [],
            displayFormView: false,
            feedResourceConfigurations: [],
        };
    },
    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin'
        ]),
        toLoad (){
            return [
                {
                    name: 'feedResources',
                    model: 'feedResources',
                    filters: {
                        archived: false,
                        is_manual: true,
                        'status!': 'FINISHED',
                    }
                },
                {
                    name: 'feedResourceConfigurations',
                    model: 'feedResourceConfigurations',
                },
                {
                    name: 'universes',
                    model: 'universes',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
            ];
        },
    },
    methods:{
        onDataFetched (res){
            this.$set(this, 'broadcastRights', res.broadcastRights);
            this.$set(this, 'feedResources', res.feedResources);
            this.$set(this, 'feedResourceConfigurations', res.feedResourceConfigurations);
            this.$set(this, 'universes', res.universes);
            this.$set(this, 'events', res.events);
            if (this.selectedFeedResource && this.selectedFeedResource.uid) {
                this.$set(
                    this,
                    'selectedFeedResource',
                    res.feedResources
                        .find(feedResource => feedResource.uid === this.selectedFeedResource.uid)
                );
            }
            this.contentLoaded = true;
            if(this.selectedFeedResource === null && this.$route.params.feedResourcesUid){
                const feedResource = this.feedResources
                    .find((f) => f.uid === this.$route.params.feedResourcesUid);
                this.selectFeedResource(feedResource);
                if(this.$route.params.edit){
                    this.onUpdateFeedResource();
                }
            }
        },
        onCreateFeedResource(){
            this.$set(this, 'selectedFeedResource', null);
            this.displayFormView = true;
        },
        onUpdateFeedResource(){
            this.displayFormView = true;
        },
        feedResourceCreated(){
            this.triggerRefresh();
            this.leaveFormView();
        },
        leaveFormView (){
            this.displayFormView = false;
        },
        unselectFeedResource() {
            this.$set(this, 'selectedFeedResource', null);
            this.triggerRefresh();
        },
        selectFeedResource (feedResource){
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedFeedResource', feedResource);
        },
        triggerRefresh(){
            this.$refs.nsLoader.triggerRefresh();
        },
        getUpdatedFeedResource(feedResourceUid){
            this.$store.dispatch('remoteGet', {url: `feed-resource/?uid=${feedResourceUid}`})
            .then(res =>{
                this.$set(this, 'selectedFeedResource', res.data.results[0]);
            });
        },
        onUpdateRights(){
            this.$refs.nsLoader.triggerRefresh().then(() => {
                this.$eventBus.$emit('broadcast-right-save-ended');
            });
        },
    }
};
</script>

<style lang="scss">
    .right-part, .left-part{
        height: 100%;
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/index.vue